import { theme } from '@approvalmax/theme';
import { Box, Text } from '@approvalmax/ui/src/components';
import styled from 'styled-components';

export const Title = styled(Text)``;

export const ConnectBox = styled(Box)`
    transition: box-shadow 0.2s;

    &:hover {
        box-shadow: inset 0 0 0 2px ${theme.color.midnight80};

        ${Title} {
            text-decoration: underline;
        }
    }
`;

export const ConnectButton = styled.button`
    cursor: pointer;
`;
